var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"mx-5",attrs:{"row":"","xs12":"","wrap":""}},[_c('enfase'),_c('criterio'),_c('formato'),_c('ferramenta'),_c('descricao')],1)}
var staticRenderFns = []

export { render, staticRenderFns }